// Dashboard App usage platforms page translations (en-US), loaded into dashboard.usage.platforms by ../en-US.usage.js
module.exports = {
  menu: "Platforms",
  title: "Platforms",
  description: "Operating system, versions and device models.",
  kpis: {
    android: "Android",
    ios: "iPhone",
    topAndroid: "Most used Android",
    topIos: "Most used iOS",
  },
  info: {
    android: "Share of the users active in the period who used the app on Android.\nSource: Google Analytics.",
    ios: "Share of the users active in the period who used the app on iPhone.\nSource: Google Analytics.",
    topAndroid: "Android version most used by the users active in the period.\nSource: Google Analytics.",
    topIos: "iOS version most used by the users active in the period.\nSource: Google Analytics.",
  },
  hints: {
    users: "{n} users",
    ofAndroid: "{pct} of Android",
    ofIos: "{pct} of iPhone",
  },
  systems: {
    android: "Android",
    ios: "iPhone",
  },
  panels: {
    systems: "Operating system",
    devicesSub: "devices",
    android: "Android version",
    ios: "iOS version",
    versionTitle: "{system} {version} · {n} users",
    devices: "Top devices",
    devicesNote: "Helps to find bugs specific to a model.",
    crashes: "Crashes per Android device",
    crashesNote: "App errors (app_exception) recorded by Firebase.",
  },
  panelInfo: {
    systems: "Users active in the period by operating system.\nSource: Google Analytics.",
    android: "Users active in the period by Android version.\nSource: Google Analytics.",
    ios: "Users active in the period by iOS version.\nSource: Google Analytics.",
    devices: "Device models with the most users active in the period.\nSource: Google Analytics.",
    crashes: "App errors (app_exception) per Android device in the period.\nSource: Google Analytics (app_exception event).",
  },
};
